import dayjs from 'dayjs';

import { cn, getInitialsStyle, initials } from '@/lib/utils';

interface ListItemProps extends React.HTMLAttributes<HTMLDivElement> {
  inspectionId: string;
  contactFullName: string;
  createdAt: Date;
}

function ListItem({ className, inspectionId, contactFullName, createdAt, ...props }: ListItemProps) {
  return (
    <div
      key={inspectionId}
      className={cn('active:bg-grey-2 flex h-[86px] w-full cursor-pointer flex-col items-start gap-1 rounded-md bg-white p-2.5 shadow-sm', className)}
      {...props}>
      <div className="flex h-[40px] w-full flex-row items-center gap-x-2.5 p-0">
        <div
          className={`box-border flex h-[36px] w-[40px] flex-row items-center justify-center p-0 ${getInitialsStyle(initials(contactFullName))} rounded-full text-lg font-bold text-white`}>
          {initials(contactFullName)}
        </div>
        <div className="text-default-text h-[21px] w-full text-sm font-medium">{contactFullName}</div>
      </div>
      <div className="flex h-[21px] w-full flex-row items-start gap-x-2.5 p-0">
        <div className="text-secondary-text h-[21px] w-full text-sm font-normal">Created Date: {dayjs(createdAt).format('MMM DD, YYYY hh:mm A')}</div>
      </div>
    </div>
  );
}

export { ListItem };
